import { createEntityAdapter } from "@reduxjs/toolkit";
import { datetimeToDate, datetimeToTime } from "utils/time";
import apiSlice from "../api/apiSlice";

const omieAdapter = createEntityAdapter({});

export const omieApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getOMIEData: builder.query({
      query: () => ({
        url: `/omie`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      transformResponse: (responseData) => {
        if (responseData) {
          return responseData.map((obj) => ({
            ...obj,
            date: datetimeToDate(obj.datetime_timestamp),
            time: datetimeToTime(obj.datetime_timestamp),
          }));
        }
        return [];
      },
    }),
    getOMIEDataBetweenDates: builder.query({
      query: ({ startDate, endDate, granularity }) => ({
        url:
          `/omie?` +
          `granularity=${granularity}&` +
          `start_date=${startDate}&` +
          `end_date=${endDate}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      transformResponse: (responseData) => {
        if (responseData) {
          return responseData.map((obj) => ({
            ...obj,
            date: datetimeToDate(obj.datetime_timestamp),
            time: datetimeToTime(obj.datetime_timestamp),
          }));
        }
        return [];
      },
    }),
    getOMIEDataFiltered: builder.query({
      query: ({ limit, page, date, time, sortColumn, sortDirection }) => ({
        url:
          `/omie/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${sortDirection ? `&sortDirection=${sortDirection}` : ""}` +
          `${sortColumn ? `&sortColumn=${sortColumn}` : ""}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetOMIEDataQuery, useGetOMIEDataFilteredQuery, useGetOMIEDataBetweenDatesQuery } =
  omieApiSlice;

export const { selectAll: selectAllOMIEData } = omieAdapter.getSelectors();
